export const STORAGE_KEY = "opti-common-header:selections";
export const ALL_PAGES_SIZE = 10000;
export const DEFAULT_PAGE_SIZE = 18;

export const DASHBOARD_PRODUCT_ID = "Home";
export const APP_DIRECTORY_PRODUCT_ID = "App Directory";

export const APP_DIRECTORY_PRODUCT_MAPPINGS = {
  4690808: "Campaign",
  4690802: "Commerce Connect",
  4690803: "Configured Commerce",
  4690800: "Content Management System",
  4690801: "Content Marketing Platform",
  4690806: "Data Platform",
  4691085: "Email",
  4690805: "Feature Experimentation",
  4728474: "Personalization",
  4690807: "Recommendations",
  4690804: "Web Experimentation"
};

export const APP_DIRECTORY_CATEGORY_MAPPINGS = {
  4474121: "Analytics",
  4474123: "Chat, Reviews, & Loyalty",
  4474127: "CRM",
  4474125: "Digital Asset Management (DAM)",
  4474126: "Email",
  4474129: "Marketing Automation",
  4474124: "Media",
  4474130: "Payments",
  4474131: "Product Information Management (PIM)",
  4474132: "Punchout",
  4474134: "Site Management",
  4474133: "Site Optimization",
  4474135: "Templates",
  4474128: "Translations",
  4474122: "Voice"
};

export const APP_DIRECTORY_PRICE_MAPPINGS = {
  4723820: "Free",
  4723822: "Trial",
  4723821: "Paid",
};

export const MARKETING_PAGE_URL = "https://www.optimizely.com/apps"


export function debounce(func, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
};
